import { handleSubscriptionsVersion } from '@corva/ui/clients/subscriptions/constants';

import * as subscriptionsV1 from './subscriptions/subscriptions.v1';
import * as subscriptionsV2 from './subscriptions/subscriptions.v2';

export const subscribeAppForAsset = handleSubscriptionsVersion(
  subscriptionsV1.subscribeAppForAsset,
  subscriptionsV2.subscribeAppForAsset
);

export const unsubscribeAppFromAsset = handleSubscriptionsVersion(
  subscriptionsV1.unsubscribeAppFromAsset,
  subscriptionsV2.unsubscribeAppFromAsset
);

export const { reloadAppDataForAsset } = subscriptionsV1;

export const subscribeForUserData = handleSubscriptionsVersion(
  subscriptionsV1.subscribeForUserData,
  subscriptionsV2.subscribeForUserData
);

export const unsubscribeFromUserData = handleSubscriptionsVersion(
  subscriptionsV1.unsubscribeFromUserData,
  subscriptionsV2.unsubscribeFromUserData
);

export const subscribeForCompanyData = handleSubscriptionsVersion(
  subscriptionsV1.subscribeForCompanyData,
  subscriptionsV2.subscribeForCompanyData
);

export const unsubscribeFromCompanyData = handleSubscriptionsVersion(
  subscriptionsV1.unsubscribeFromCompanyData,
  subscriptionsV2.unsubscribeFromCompanyData
);

export const connect = handleSubscriptionsVersion(subscriptionsV1.connect, subscriptionsV2.connect);

export const disconnect = handleSubscriptionsVersion(
  subscriptionsV1.disconnect,
  subscriptionsV2.disconnect
);
